setTimeout(() => {
    document.querySelectorAll('.FilterFloorRange').forEach((el) => {
        const inputEls = el.querySelectorAll('.FilterFloorRange__form input[type=number]');
        let slider = el.querySelector('.RangeDouble__range');
        if(slider) {
            slider = slider.noUiSlider;
        }
        const checkbox = el.querySelector('.FilterFloorRange__form input[type=checkbox]');

        if(slider) {
            slider.on('update', function (values) {
                values.forEach((v, i) => {
                    inputEls[i].value = parseInt(v);
                });
            });
            inputEls.forEach((el, i) => {
                el.addEventListener('input', debounce(() => {
                    const arr = new Array(2);
                    arr[i] = parseInt(el.value);
                    slider.set(arr);
                }, 500));
            });
            checkbox.addEventListener('input', () => {
                const n = checkbox.checked ? 1 : 0;
                let [min, max] = slider.options.start;
                min += n;
                max -= n;
                slider.set([min, max]);

                inputEls.forEach((input) => {
                    input.disabled = checkbox.checked;
                    checkbox.checked ? slider.disable() : slider.enable();
                })
            });
        }


        //checkbox.dispatchEvent(new Event('input'));
    });
}, 100);
